export default __webpack_public_path__ + "static/home_slider3.png";